//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    subscribe(body: SubscriptionDto | undefined): Promise<SubscriptionDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    unSubscribe(body: UnsubscriptionDto | undefined): Promise<UnsubscriptionDto>;

    /**
     * @param continent (optional) 
     * @param includePlaces (optional) 
     * @return Success
     */
    getAllCountries(continent: WorldContinent | undefined, includePlaces: boolean | undefined): Promise<CountryDto[]>;

    /**
     * @param countryId (optional) 
     * @param includePlaces (optional) 
     * @return Success
     */
    getCountryDetails(countryId: string | undefined, includePlaces: boolean | undefined): Promise<CountryDto>;

    /**
     * @param placeId (optional) 
     * @return Success
     */
    getPlaceDetails(placeId: string | undefined): Promise<PlaceDetailDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    find(body: FindPlaceDto | undefined): Promise<FoundDto[]>;

    /**
     * @param countryId (optional) 
     * @param includeRatings (optional) 
     * @return Success
     */
    getPlaces(countryId: string | undefined, includeRatings: boolean | undefined): Promise<PlaceDto[]>;

    /**
     * @param placeId (optional) 
     * @return Success
     */
    getPlace(placeId: string | undefined): Promise<PlaceDto>;

    /**
     * @param includeRatings (optional) 
     * @param body (optional) 
     * @return Success
     */
    findPlaces(includeRatings: boolean | undefined, body: FindPlaceDto | undefined): Promise<PlaceDto[]>;

    /**
     * @param includeRatings (optional) 
     * @param body (optional) 
     * @return Success
     */
    findPlacesByPersonality(includeRatings: boolean | undefined, body: FindPlacePersonalityDto | undefined): Promise<PlaceDto[]>;

    /**
     * @return Success
     */
    getAllAttractions(): Promise<AttractionDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    getContinentPlaces(body: FindPlaceDto | undefined): Promise<PlaceBasicDto[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    getRandomPlaces(body: FindPlaceDto | undefined): Promise<PlaceBasicDto[]>;
}

export class Client implements IClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    subscribe(body: SubscriptionDto | undefined): Promise<SubscriptionDto> {
        let url_ = this.baseUrl + "/Communication/Subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubscribe(_response);
        });
    }

    protected processSubscribe(response: Response): Promise<SubscriptionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unSubscribe(body: UnsubscriptionDto | undefined): Promise<UnsubscriptionDto> {
        let url_ = this.baseUrl + "/Communication/UnSubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnSubscribe(_response);
        });
    }

    protected processUnSubscribe(response: Response): Promise<UnsubscriptionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnsubscriptionDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnsubscriptionDto>(null as any);
    }

    /**
     * @param continent (optional) 
     * @param includePlaces (optional) 
     * @return Success
     */
    getAllCountries(continent: WorldContinent | undefined, includePlaces: boolean | undefined): Promise<CountryDto[]> {
        let url_ = this.baseUrl + "/Continent/GetAllCountries?";
        if (continent === null)
            throw new Error("The parameter 'continent' cannot be null.");
        else if (continent !== undefined)
            url_ += "continent=" + encodeURIComponent("" + continent) + "&";
        if (includePlaces === null)
            throw new Error("The parameter 'includePlaces' cannot be null.");
        else if (includePlaces !== undefined)
            url_ += "includePlaces=" + encodeURIComponent("" + includePlaces) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCountries(_response);
        });
    }

    protected processGetAllCountries(response: Response): Promise<CountryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto[]>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param includePlaces (optional) 
     * @return Success
     */
    getCountryDetails(countryId: string | undefined, includePlaces: boolean | undefined): Promise<CountryDto> {
        let url_ = this.baseUrl + "/Country/GetCountryDetails?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (includePlaces === null)
            throw new Error("The parameter 'includePlaces' cannot be null.");
        else if (includePlaces !== undefined)
            url_ += "includePlaces=" + encodeURIComponent("" + includePlaces) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountryDetails(_response);
        });
    }

    protected processGetCountryDetails(response: Response): Promise<CountryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto>(null as any);
    }

    /**
     * @param placeId (optional) 
     * @return Success
     */
    getPlaceDetails(placeId: string | undefined): Promise<PlaceDetailDto> {
        let url_ = this.baseUrl + "/Place/GetPlaceDetails?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlaceDetails(_response);
        });
    }

    protected processGetPlaceDetails(response: Response): Promise<PlaceDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlaceDetailDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaceDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    find(body: FindPlaceDto | undefined): Promise<FoundDto[]> {
        let url_ = this.baseUrl + "/Place/Find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFind(_response);
        });
    }

    protected processFind(response: Response): Promise<FoundDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FoundDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FoundDto[]>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param includeRatings (optional) 
     * @return Success
     */
    getPlaces(countryId: string | undefined, includeRatings: boolean | undefined): Promise<PlaceDto[]> {
        let url_ = this.baseUrl + "/Place/GetPlaces?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (includeRatings === null)
            throw new Error("The parameter 'includeRatings' cannot be null.");
        else if (includeRatings !== undefined)
            url_ += "includeRatings=" + encodeURIComponent("" + includeRatings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlaces(_response);
        });
    }

    protected processGetPlaces(response: Response): Promise<PlaceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlaceDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaceDto[]>(null as any);
    }

    /**
     * @param placeId (optional) 
     * @return Success
     */
    getPlace(placeId: string | undefined): Promise<PlaceDto> {
        let url_ = this.baseUrl + "/Place/GetPlace?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlace(_response);
        });
    }

    protected processGetPlace(response: Response): Promise<PlaceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlaceDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaceDto>(null as any);
    }

    /**
     * @param includeRatings (optional) 
     * @param body (optional) 
     * @return Success
     */
    findPlaces(includeRatings: boolean | undefined, body: FindPlaceDto | undefined): Promise<PlaceDto[]> {
        let url_ = this.baseUrl + "/Place/FindPlaces?";
        if (includeRatings === null)
            throw new Error("The parameter 'includeRatings' cannot be null.");
        else if (includeRatings !== undefined)
            url_ += "includeRatings=" + encodeURIComponent("" + includeRatings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFindPlaces(_response);
        });
    }

    protected processFindPlaces(response: Response): Promise<PlaceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlaceDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaceDto[]>(null as any);
    }

    /**
     * @param includeRatings (optional) 
     * @param body (optional) 
     * @return Success
     */
    findPlacesByPersonality(includeRatings: boolean | undefined, body: FindPlacePersonalityDto | undefined): Promise<PlaceDto[]> {
        let url_ = this.baseUrl + "/Place/FindPlacesByPersonality?";
        if (includeRatings === null)
            throw new Error("The parameter 'includeRatings' cannot be null.");
        else if (includeRatings !== undefined)
            url_ += "includeRatings=" + encodeURIComponent("" + includeRatings) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFindPlacesByPersonality(_response);
        });
    }

    protected processFindPlacesByPersonality(response: Response): Promise<PlaceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlaceDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaceDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllAttractions(): Promise<AttractionDto[]> {
        let url_ = this.baseUrl + "/Place/GetAllAttractions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAttractions(_response);
        });
    }

    protected processGetAllAttractions(response: Response): Promise<AttractionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttractionDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttractionDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getContinentPlaces(body: FindPlaceDto | undefined): Promise<PlaceBasicDto[]> {
        let url_ = this.baseUrl + "/Place/GetContinentPlaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContinentPlaces(_response);
        });
    }

    protected processGetContinentPlaces(response: Response): Promise<PlaceBasicDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlaceBasicDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaceBasicDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRandomPlaces(body: FindPlaceDto | undefined): Promise<PlaceBasicDto[]> {
        let url_ = this.baseUrl + "/Place/GetRandomPlaces";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRandomPlaces(_response);
        });
    }

    protected processGetRandomPlaces(response: Response): Promise<PlaceBasicDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlaceBasicDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaceBasicDto[]>(null as any);
    }
}

export interface AttractionDto {
    id?: string;
    name?: string | undefined;
}

export interface AttractionLevelDto {
    attractionId?: string;
    level?: number;
}

export interface CountryDetailDto {
    id?: string;
    tags?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
}

export interface CountryDto {
    id?: string;
    name?: string | undefined;
    continentName?: string | undefined;
    continentNumber?: number;
    countryCode?: string | undefined;
    places?: PlaceDto[] | undefined;
    countryDetails?: CountryDetailDto[] | undefined;
}

export interface FindPlaceDto {
    filterContinent?: boolean;
    continent?: WorldContinent;
    filterCountry?: boolean;
    countryId?: string;
    desiredAttractions?: AttractionLevelDto[] | undefined;
    rowNumbers?: number;
    searchTerm?: string | undefined;
}

export interface FindPlacePersonalityDto {
    personality?: string | undefined;
    rowNumbers?: number;
}

export interface FoundDto {
    id?: string;
    name?: string | undefined;
    foundType?: FoundType;
    parentName?: string | undefined;
    countryCode?: string | undefined;
}

export enum FoundType {
    _0 = 0,
    _1 = 1,
}

export enum LinkType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum MediaType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface PlaceBasicDto {
    id?: string;
    name?: string | undefined;
    countryId?: string;
    countryName?: string | undefined;
}

export interface PlaceDetailDto {
    id?: string;
    tags?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
}

export interface PlaceDto {
    id?: string;
    name?: string | undefined;
    countryId?: string;
    website?: string | undefined;
    description?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    countryName?: string | undefined;
    placeLinks?: PlaceLinkDto[] | undefined;
    ratings?: RatingDto[] | undefined;
    thingsToDos?: ThingsToDoDto[] | undefined;
    placeDetails?: PlaceDetailDto[] | undefined;
}

export interface PlaceLinkDto {
    id?: string;
    url?: string | undefined;
    linkType?: LinkType;
    mediaType?: MediaType;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface RatingDto {
    id?: string;
    attractionId?: string;
    placeId?: string;
    ratingValue?: number;
    attraction?: string | undefined;
}

export interface SubscriptionDto {
    name: string;
    email: string;
}

export interface ThingsToDoDto {
    id?: string;
    description?: string | undefined;
    placeId?: string;
}

export interface UnsubscriptionDto {
    email: string;
}

export enum WorldContinent {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}